module.exports = __webpack_public_path__ + "static/foamshapes-3b0bd17dc466fb8cd504bfe6d6cda28d.jpeg";